var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    viewBox: "0 0 24 24",
    width: "100%",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    height: 24,
    id: "Artboard12",
    style: {
      fill: "none"
    },
    width: 24,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 20,
    width: 20,
    x: 2,
    y: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.602,6.448l-3.698,0l-2.631,6.621l-2.99,-6.621l-3.951,0l0,0.329l1.392,1.701l-0.019,6.57l-1.376,1.878l0.003,0.311l3.886,0l0.01,-0.286l-1.628,-1.903l0.043,-5.317l3.433,7.506l0.414,0l3.049,-7.684l0,6.25l-1.25,1.182l0,0.252l5.313,0l0,-0.302l-1.218,-1.155l-0.017,-7.946l1.235,-1.055l0,-0.331Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/medium-icon.4ddd88d5.svg";
export { ForwardRef as ReactComponent };